import {CreateProject, Project} from '@/model/Project'

export default {
  prepareDataToApi(project: Project): CreateProject {
    return {
      authorId: project.author?.id as string,
      name: project.name,
      mainImage: (project.mainImage as any)?.id || project.mainImage,
      description: project.description,
      content: project.content,
      status: project.status ?? '',
      startsAt: project.startsAt,
      tags: project.tags,
      category: project.category,
      assets: project.assets
    }
  },
}
